import React, { useState, useEffect } from "react";
import axios from "axios";

const Courses = ({ platformUrl }) => {
    const [courses, setCourses] = useState([]);
    const [sortedCourses, setSortedCourses] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [error, setError] = useState(null);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get("token");
        const uuid = params.get("uuid"); // Assuming uuid is passed in the URL

        if (!token || !uuid) {
            setError("Missing access token or UUID. Please log in.");
            return;
        }

        const fetchUserMembershipsAndCourses = async () => {
            try {
                // Step 1: Get the user ID using the UUID
                const userResponse = await axios.get(
                    `${platformUrl}/learn/api/public/v1/users/uuid:${uuid}`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
                const userId = userResponse.data.id;

                // Step 2: Fetch memberships for the user
                const membershipsResponse = await axios.get(
                    `${platformUrl}/learn/api/public/v1/users/${userId}/courses`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
                const memberships = membershipsResponse.data.results;

                // Step 3: Fetch course details for each membership
                const coursePromises = memberships.map((membership) =>
                    axios
                        .get(
                            `${platformUrl}/learn/api/public/v3/courses/${membership.courseId}`,
                            {
                                headers: { Authorization: `Bearer ${token}` },
                            }
                        )
                        .then((res) => ({
                            ...res.data,
                            membershipRole: membership.courseRoleId, // Include the membership role
                        }))
                );

                const coursesWithDetails = await Promise.all(coursePromises);

                // Step 4: Set the course data
                setCourses(coursesWithDetails);
                setSortedCourses(coursesWithDetails);
            } catch (err) {
                setError(err.message);
            }
        };

        fetchUserMembershipsAndCourses();
    }, []);

    const sortCourses = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const sortedData = [...courses].sort((a, b) => {
            if (a[key] < b[key]) {
                return direction === 'asc' ? -1 : 1;
            }
            if (a[key] > b[key]) {
                return direction === 'asc' ? 1 : -1;
            }
            return 0;
        });

        setSortConfig({ key, direction });
        setSortedCourses(sortedData);
    };

    if (error) {
        return (
            <div className="bb-container bb-error">
                <div className="banner">
                    <a href="https://www.uky.edu" target="_blank" rel="noopener noreferrer">
                        <img
                            src="https://myuk.uky.edu/irj/portal/img/My_UK_logo.png"
                            alt="University of Kentucky"
                            className="banner-image"
                        />
                    </a>
                </div>
                <h1 className="bb-title">Error</h1>
                <p>{error}</p>
                <p>
                    Please start the login process by accessing the provided
                    login link.
                </p>
            </div>
        );
    }

    return (
        <div className="bb-container">
            <div className="banner">
                <a href="https://www.uky.edu" target="_blank" rel="noopener noreferrer">
                    <img
                        src="https://myuk.uky.edu/irj/portal/img/My_UK_logo.png"
                        alt="University of Kentucky"
                        className="banner-image"
                    />
                </a>
            </div>
            <h1 className="bb-title">My Course Roster</h1>
            <table className="bb-table">
                <thead>
                    <tr>
                        <th onClick={() => sortCourses('courseId')}>Course ID</th>
                        <th onClick={() => sortCourses('name')}>Course Name</th>
                        <th onClick={() => sortCourses('ultraStatus')}>Ultra Status</th>
                        <th onClick={() => sortCourses('membershipRole')}>Membership Role</th>
                        <th onClick={() => sortCourses('availability')}>Availability</th>
                        <th onClick={() => sortCourses('externalAccessUrl')}>External Access</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedCourses.map((course) => (
                        <tr key={course.id}>
                            <td>{course.courseId}</td>
                            <td>{course.name}</td>
                            <td>{course.ultraStatus}</td>
                            <td>{course.membershipRole}</td>
                            <td>{course.availability?.available ? "Available" : "Unavailable"}</td>
                            <td>
                                {course.externalAccessUrl ? (
                                    <a
                                        href={course.externalAccessUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Open Course
                                    </a>
                                ) : (
                                    "N/A"
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Courses;

